<template>
  <v-layout row wrap >
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color: #EEEEEE;" >
        <v-toolbar dark color="primary">
          <!-- <v-tooltip bottom> -->
            <v-btn icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <!-- <span>{{$t('close')}}</span>
          </v-tooltip> -->
          <v-toolbar-title>
            {{ json_data.save_type == 'create' ? $t('menu.ChangeSalaryCreate') :
            $t('menu.ChangeSalaryEdit') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-3 >
            <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-btn
                  dark
                  v-if="buttonlist == 1 "
                  color="blue-grey darken-2"
                  @click="checkbutton(0)"
                >
                  <v-icon dark>person_add</v-icon>
                  <span>&nbsp;{{$t('AddIndividual')}}</span>
                </v-btn>
                <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(0)">
                  <v-icon dark>person_add</v-icon>
                  <span>&nbsp;{{$t('AddIndividual')}}</span>
                </v-btn>
                <v-btn
                  dark
                  v-if="buttonlist == 0 "
                  color="blue-grey darken-2"
                  @click="checkbutton(1)"
                >
                  <v-icon dark>group_add</v-icon>
                  <span>&nbsp;{{$t('Add_As_A_Group')}}</span>
                </v-btn>
                <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(1)">
                  <v-icon dark>group_add</v-icon>
                  <span>&nbsp;{{$t('Add_As_A_Group')}}</span>
                </v-btn>
              </v-flex>
              <v-flex xs12 v-if="buttonlist == 1">
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <!--                     
                    <v-flex md4 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('date')"
                        type="date"
                        v-model="datas.date"
                        required
                        hide-details
                      />
                    </v-flex>
                    <v-flex md4 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('remark')"
                        type="text"
                        v-model="datas.remark"
                        required
                        hide-details
                      />
                    </v-flex>-->

                    <v-flex md4 sm6 xs12 pa-1>
                      <v-select
                        required
                        :items="branch_items"
                        :label="$t('branch')"
                        item-text="name"
                        item-value="code"
                        v-model="branch"
                        hide-details
                        @input="getProfileDepartmentList()"
                      />
                    </v-flex>
                    <v-flex md4 sm6 xs12 pa-1>
                      <v-select
                        required
                        :items="department_items"
                        :label="$t('Department')"
                        item-text="name"
                        item-value="code"
                        v-model="department"
                        hide-details
                        :disabled="department_items.length ==''"
                        @input="getEmployeeList()"
                      />
                    </v-flex>

                    <v-flex md4 sm6 xs12 pa-1>
                      <v-select
                        v-model="name"
                        :items="Employee_list"
                        item-text="name"
                        item-value="name"
                        :label="$t('employee_code')"
                        :disabled="Employee_list.length ==''"
                        multiple
                      >
                        <template slot="prepend-item">
                          <v-list-tile ripple @click="toggle" class="checkEmp">
                            <v-list-tile-action>
                              <v-checkbox
                                v-model="isChecked"
                                color="primary"
                                :indeterminate="selectSomeEmp"
                              ></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>Select All</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <template slot="append-item">
                          <v-divider class="mb-2"></v-divider>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex md2 sm4 xs12 style="margin-right:15px;">
                      <v-btn
                        color="warning"
                        block
                        class="white--text"
                        @click="dialog_create = true;"
                      >
                        <p style=" font-size:12px;padding: 10px 0;">{{$t('DownloadExample')}}</p>
                      </v-btn>
                    </v-flex>
                    <v-flex md2 sm4 xs12 class="button-wrapper">
                      <span class="label">{{$t('Upload')}}</span>
                      <input
                        :label="$t('ImportIncome')"
                        type="file"
                        id="file"
                        ref="myFiles"
                        class="upload-box"
                        multiple
                        @change="ImportExcel()"
                        placeholder="Upload File"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-flex md12 sm12 xs12>
                  <v-layout row wrap v-if="results.length > 0">
                    <v-flex
                      md12
                      sm12
                      xs12
                      v-for="(item, index) in IncomeData"
                      :key="index"
                      @click="''"
                    >
                      <v-card class="coco-box-shadow">
                        <v-layout
                          align-center
                          justify-center
                          row
                          fill-height
                          wrap
                          class="coco-list-layout"
                        >
                          <v-flex lg1 md1 sm2 xs3 text-xs-center>
                            <v-avatar :size="64">
                              <v-avatar
                                v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                                :size="64"
                                color="teal"
                              >
                                <span class="white--text headline">{{item.nick_name}}</span>
                              </v-avatar>

                              <Empimage
                                v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                                :json_data="item.emp_images"
                              />
                            </v-avatar>
                          </v-flex>
                          <v-flex lg9 md9 sm8 xs9>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span>{{isEmpty(item.emp_code)? item.emp_code : 'ไม่พบข้อมูล พนักงาน'}}</span>
                                <span>: {{item.name}}</span>
                              </v-flex>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{$t('Salary')}}:
                                  <span>
                                    {{isEmpty(item.amount)? item.amount
                                    : 'amount'}}
                                  </span>
                                </span>
                                <!-- <span class="coco-list-label-text">
                                  {{$t('craftAmount')}}:
                                  <span>
                                    {{isEmpty(item.craftamount)? item.craftamount
                                    : 'craftamount'}}
                                  </span>
                                </span>
                                <span class="coco-list-label-text">
                                  {{$t('PositionAmount')}}:
                                  <span>
                                    {{isEmpty(item.positionamount)? item.positionamount
                                    : 'positionamount'}}
                                  </span>
                                </span> -->
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md2 xs12>
                            <v-layout row wrap>
                              <v-flex md12 sm12 xs12 text-xs-center>
                                <v-layout row wrap>
                                  <v-flex offset-lg5 offset-md3 offset-xs8 lg3 md4 xs2>
                                    <v-tooltip bottom>
                                      <v-btn
                                        slot="activator"
                                        color="warning"
                                        icon
                                        flat
                                        @click="EditItem(item,index)"
                                      >
                                        <v-icon>edit</v-icon>
                                      </v-btn>
                                      <span>{{$t('edit')}}</span>
                                    </v-tooltip>
                                  </v-flex>
                                  <v-flex lg3 md4 xs2>
                                    <v-tooltip bottom>
                                      <v-btn
                                        slot="activator"
                                        color="error"
                                        icon
                                        flat
                                        @click="deleteItem(item,index)"
                                      >
                                        <v-icon>delete</v-icon>
                                      </v-btn>
                                      <span>{{$t('delete')}}</span>
                                    </v-tooltip>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex
                            xs12
                            offset-md1
                            offset-sm2
                            class="coco-list-divider"
                            style="margin-top : 10px; margin-bottom : 10px;"
                          >
                            <v-divider />
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 text-xs-right>
                      <v-btn color="#D84315" @click="back()">
                        <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                        <span style="color:#ffffff">{{$t('back')}}</span>
                      </v-btn>
                      <v-btn color="#43A047" @click="dialog = false;onSaveGroup()">
                        <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                        <span style="color:#ffffff">{{$t('save')}}</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs12 v-if="buttonlist==0">
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('date')"
                        type="date"
                        v-model="form_model.approve_date"
                        :rules="form_rules.approve_date"
                        required
                        hide-details
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-autocomplete
                        hide-details
                        :loading="loading"
                        v-model="form_model.emp_code"
                        :items="Employee_List"
                        item-text="name"
                        item-value="code"
                        :label="$t('employee_code')"
                        allow-overflow
                        append-icon="search"
                        clearable
                        required
                        :rules="form_rules.emp_code"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('amount')"
                        v-model="form_model.amount"
                        :rules="form_rules.amount"
                        required
                        type="number"
                        hide-details
                        :min="0"
                        @change="form_model.amount = Math.min(form_model.amount)"
                      />
                    </v-flex>
                    <!-- <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('craftAmount')"
                        v-model="form_model.craftamount"
                        required
                        type="number"
                        hide-details
                        :min="0"
                        @change="form_model.craftamount = Math.min(form_model.craftamount)"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('PositionAmount')"
                        v-model="form_model.positionamount"
                        required
                        type="number"
                        hide-details
                        :min="0"
                        @change="form_model.positionamount = Math.min(form_model.positionamount)"
                      />
                    </v-flex> -->
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea
                        :label="$t('remark')"
                        v-model="form_model.remark"
                        required
                        hide-details
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right v-if="buttonlist == 0">
              <!-- <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()"> -->
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-layout row justify-center>
      <v-dialog v-model="dialog_create" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('menu.profile')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('date')"
                    type="date"
                    v-model="form_dialog_create.date"
                    required
                    hide-details
                    :rules="form_rules.date"
                  />
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('detail')" v-model="form_dialog_create.remark" required />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog_create = false">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="DownloadExampleExcel()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- EDIT -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('menu.profile')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('code')"
                    v-model="form_dialog.emp_code"
                    required
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('name')" v-model="form_dialog.name" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field :label="$t('amount')" v-model="form_dialog.amount" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('craftAmount')"
                    v-model="form_dialog.craftamount"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('craftAmount')"
                    v-model="form_dialog.positionamount"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    :label="$t('effective_date')"
                    v-model="form_dialog.approve_date"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" flat @click="dialog = false;onUpdateGroup()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Empimage from "../../components/getempimage.vue";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  props: {
    json_data: Object
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
      } else {
        this.$refs.form.resetValidation();
      }
    }
  },
  data: () => ({
    buttonlist: 0,
    branch: "",
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    isChecked: false,
    form_valid: false,
    dialog_create: false,
    dialog: false,
    results: [],
    IncomeData: [],
    form_dialog_create: {
      date: "",
      remark: ""
    },
    name: [],
    checkdata: true,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    index: 0,
    form_dialog: {
      amount: "",
      name: "",
      emp_code: "",
      detailincome: "",
      effect_date: ""
    },
    form_model: {
      emp_code: "",
      remark: "",
      amount: "0",
      craftamount: "0",
      positionamount: "0",
      approve_date: new Date().toISOString().slice(0, 10),
      creator_code: localStorage._usercode,
      company_id : localStorage._company_guid,
    },
    head_example: [
      "รหัส",
      "ชื่อ",
      "วันที่มีผล",
      "เงินเดือน",
      "ค่าตำแหน่ง",
      "ค่าฝีมือ",
      "รายละเอียด"
    ],
    detail_example: [],
    details: [],
    form_rules: {
      amount: [v => !!v || "do not empty."],
      approve_date: [v => !!v || "do not empty."],
      emp_code: [v => !!v || "do not empty."],
      date: [v => !!v || "do not empty."]
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    }
  }),

  components: {
    Empimage
  },
  created: async function() {
    await this.getProfileBranchList();
    await this.clearForm();
    await this.getEmployee("newData");
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
    selectAllEmp() {
      return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      console.log(this.name);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    clearForm() {
      this.form_model = {
        emp_code: "",
        remark: "",
        amount: "0",
        craftamount: "0",
        positionamount: "0",
        approve_date: new Date().toISOString().slice(0, 10),
        creator_code: localStorage._usercode
      };
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    checkbutton(buttonlist) {
      if (buttonlist == 1) {
        this.buttonlist = 1;
        console.log("Import");
      } else if (buttonlist == 0) {
        this.buttonlist = 0;
        console.log("Individual");
      } else if (buttonlist == 1) {
        this.buttonlist = 1;
      } else if (buttonlist == 1) {
        this.buttonlist = 1;
      }
    },

    DownloadExampleExcel() {
      let v = this;
      console.log("DownloadExampleExcel");
      console.log(v.form_dialog_create);

      if (v.name.length > 0) {
        if (v.form_dialog_create.date != "") {
          v.dialog_create = false;
          v.name.forEach(function(data) {
            let value = data.split(" - ");
            console.log(value[0] + " : " + value[1]);
            v.detail_example.push({
              รหัส: value[0],
              ชื่อ: value[1],
              วันที่มีผล: v.form_dialog_create.date,
              เงินเดือน: "0",
              ค่าตำแหน่ง: "0",
              ค่าฝีมือ: "0",
              รายละเอียด: v.form_dialog_create.remark
            });
          });
          var config = { raw: true, type: "string" };
          var Example = XLSX.utils.json_to_sheet(
            v.detail_example,
            v.head_example,
            config
          );
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, Example, "ChangeSalary");
          XLSX.writeFile(wb, "ChangeSalary.xlsx");
        } else {
          this.snack_model.status = true;
          this.snack_model.msg = "กรุณากรอกวันที่มีผล";
          this.snack_model.type = "error";
        }
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
        this.snack_model.type = "error";
      }
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
    },
back() {
      location.reload();
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        v.details = [];
        for (let index = 0; index < v.results.length; index++) {
          if (
            v.results[index].รหัส != " " &&
            v.results[index].วันที่มีผล != " " &&
            v.results[index].เงินเดือน != " " &&
            v.results[index].รายละเอียด != " " &&
            v.results[index].ค่าตำแหน่ง != " " &&
            v.results[index].ค่าฝีมือ != " "
          ) {
            v.details.push({
              emp_code: v.results[index].รหัส,
              name: v.results[index].ชื่อ,
              approve_date: v.results[index].วันที่มีผล,
              amount: v.results[index].เงินเดือน + "",
              remark: v.results[index].รายละเอียด,
              craftamount: v.results[index].ค่าตำแหน่ง + "",
              positionamount: v.results[index].ค่าฝีมือ + "",
              creator_code: localStorage._usercode
            });
          } else {
            v.snack_model.status = true;
            v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
            v.snack_model.type = "error";
          }
          v.IncomeData = v.details;
        }
        console.log(v.details);
        //   DocumentService.CheckDetail(v.details)
        //     .then(res => {
        //       v.IncomeData = res.data;
        //       console.log("CheckDetail");
        //       console.log(v.IncomeData);
        //     })
        //     .catch(err => {
        //       v.snack_model.status = true;
        //       v.snack_model.msg = "ไม่พบข้อมูล";
        //       v.snack_model.type = "error";
        //     });
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          this.branch_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then(res => {
          this.department_items = res.data;
          console.log(this.department_items);
          this.getEmployeeList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(
        this.branch,
        this.department,
        position,
        search,
        page
      )
        .then(res => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach(emp => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name
              });
            }
          });
          console.log(this.Employee_list);
        })
        .catch(err => {
          console.log(err);
        });
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_list.forEach(data => {
            this.name.push(data.name);
          });
        }
      });
    },
    onSave() {
      if (this.form_valid) {
        console.log("form_model: " , this.form_model);
        this.form_model.company_id = localStorage._company_guid;
        DocumentService.createSalaryApprove(this.form_model)
          .then(res => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch(err => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },

    onSaveGroup() {
      console.log(this.details);
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        DocumentService.createSalaryApproveList(this.details)
          .then(res => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch(err => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    onUpdateGroup() {
      let v = this;
      (v.details[v.index].name = v.form_dialog.name),
        (v.details[v.index].amount = v.form_dialog.amount),
        (v.details[v.index].craftamount = v.form_dialog.craftamount),
        (v.details[v.index].positionamount = v.form_dialog.positionamount),
        (v.details[v.index].approve_date = v.form_dialog.approve_date),
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
    },
    onUpdate() {
      if (this.form_valid) {
        DocumentService.updateSalaryApprove(this.form_model)
          .then(res => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch(err => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}
</style>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
</style>